// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stats_wrapper__6VKvM","grid":"Stats_grid__S_61m","stat":"Stats_stat__U5KpX","value":"Stats_value__SqZvq","suffix":"Stats_suffix__WqR7r","label":"Stats_label__nMFcL"};